<template>
    <div class="page-table haberTanim  mainDiv" id="affix-container">
        <div class="animated fadeInUp card-base baslikBg">{{$t("src.views.apps.haberler.tanimlama.pageBaslik")}}</div>
        <el-row :gutter="10">
            <el-form status-icon :model="haberlerForm" :rules="rulesHaberler" ref="haberlerForm"
                     class="demo-ruleForm">
                <el-col :lg="18" :md="18" :sm="24" :xs="24">
                    <el-tabs tab-position="left" class="language">
                        <el-tab-pane>
                            <span slot="label"><i class="flag-icon flag-icon-tr"></i></span>
                            <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item
                                                :label='$t("src.views.apps.haberler.tanimlama.baslik")'
                                                prop="baslik">:
                                            <div v-if="linkVisible" style="float: right; display: flex">
                                                <div v-if="!VisibleA">
                                                    <el-link target="_blank" :underline="false"
                                                             :href="this.path">
                                                        {{this.path}}{{this.haberlerForm.link}}
                                                    </el-link>
                                                </div>
                                                <el-button v-if="duzenleBtnVisible"
                                                           style="margin-left: 10px; margin-bottom: 5px"
                                                           v-on:click="VisibleA = true; duzenleBtnVisible=false"
                                                           size="mini">Düzenle
                                                </el-button>
                                                <span v-if="VisibleA">{{this.path}}</span>
                                                <el-input
                                                        v-if="VisibleA" v-model="haberlerForm.link"
                                                        v-on:change="linkChange = false;$store.commit('changeTabsClose', false)"
                                                        v-on:blur="linkTespitLink();VisibleA=false; duzenleBtnVisible=true"
                                                        style="width: 50%" size="mini"></el-input>
                                            </div>
                                            <el-input
                                                    :disabled="disabled"
                                                    v-model="haberlerForm.baslik"
                                                    v-on:change="linkTespit(); $store.commit('changeTabsClose', false)"
                                                    :placeholder='$t("src.views.apps.haberler.tanimlama.baslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.haberler.tanimlama.altbaslik")'
                                                      prop="altbaslik">:
                                            <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                      :disabled="disabled"
                                                      v-model="haberlerForm.altbaslik"
                                                      :placeholder='$t("src.views.apps.haberler.tanimlama.altbaslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.haberler.tanimlama.icerik")'
                                                      prop="icerik">:
                                            <ckeditor :editor="editor"
                                                      :config="editorConfig"
                                                      v-model="haberlerForm.icerik"
                                                      :disabled="disabled"
                                                      @input="seoIcerikTespit(); $store.commit('changeTabsClose', false)"
                                                      @blur="seoIcerikTespit(); $store.commit('changeTabsClose', false)"></ckeditor>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                            <el-collapse style="margin-top: 10px" v-model="activeCollapse">
                                <draggable
                                        data-source="juju"
                                        class="list-group"
                                        group="a">
                                    <el-collapse-item class="card-shadow--medium" title="Resim Ayarları" name="7">
                                        <el-row>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.haberler.tanimlama.resim")'
                                                              prop="resim">:
                                                    <el-upload
                                                            class="resimler"
                                                            :disabled="disabled"
                                                            action=""
                                                            list-type="picture-card"
                                                            multiple
                                                            :file-list="imageListMain"
                                                            :auto-upload="false"
                                                            accept=".jpg,.jpeg,.png"
                                                            :on-change="imageUpload"
                                                            :on-preview="firstImage"
                                                            :on-remove="imageRemove">
                                                        <i slot="default" class="el-icon-plus"></i>
                                                    </el-upload>
                                                    <el-button style="margin-top: 15px;width: 150px;" type="primary"
                                                               v-on:click="serverImageList"
                                                               @click="dialogImgServerVisible = true; " size="mini">
                                                        Sunucudan
                                                        Seç
                                                    </el-button>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-collapse-item>
                                    <el-collapse-item class="card-shadow--medium" title="SEO Ayarları" name="9">
                                        <el-row>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.seoBaslik")'
                                                              prop="seobaslik">:
                                                    <el-input v-on:change="$store.commit('changeTabsClose', false)"

                                                              :disabled="disabled"
                                                              id="seoBaslik"
                                                              @input="seoBaslikChange('seoBaslik')"
                                                              v-model="haberlerForm.seobaslik"
                                                              :placeholder='$t("src.views.apps.sayfa.tanimlama.seoBaslikPlace")'>
                                                        <template slot="append">{{seoBaslikLimit}}</template>
                                                    </el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.seoIcerik")'
                                                              prop="seoicerik">:
                                                    <el-input v-on:change="$store.commit('changeTabsClose', false)"

                                                              :disabled="disabled"
                                                              v-on:focus="seoicerikChange = false"
                                                              type="textarea"
                                                              v-model="haberlerForm.seoicerik"></el-input>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-collapse-item>
                                </draggable>
                            </el-collapse>
                        </el-tab-pane>
                        <el-tab-pane v-if="$store.state.dilDurum">
                            <span slot="label"><i class="flag-icon flag-icon-gb"></i></span>
                            <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.dil.en.baslik")'
                                                      prop="dil.en.baslik">:
                                            <el-input
                                                    v-model="haberlerForm.dil.en.baslik"
                                                    v-on:change="$store.commit('changeTabsClose', false) ;haberlerForm.dil.en.seobaslik = haberlerForm.dil.en.baslik.substring(0, 60)"
                                                    :placeholder='$t("src.views.apps.sayfa.tanimlama.baslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.dil.en.altbaslik")'
                                                      prop="dil.en.altbaslik">:
                                            <el-input v-on:change="$store.commit('changeTabsClose', false)"

                                                      v-model="haberlerForm.dil.en.altbaslik"
                                                      :placeholder='$t("src.views.apps.sayfa.tanimlama.altBaslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.dil.en.icerik")'
                                                      prop="dil.en.icerik">:
                                            <ckeditor :editor="editor"
                                                      :config="editorConfig"
                                                      v-model="haberlerForm.dil.en.icerik"
                                                      @input="seoIcerikDilTespit(); $store.commit('changeTabsClose', false)"
                                                      @blur="seoIcerikDilTespit(); $store.commit('changeTabsClose', false)"></ckeditor>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                            <el-collapse style="margin-top: 10px" v-model="activeCollapse">
                                <draggable
                                        data-source="juju"
                                        class="list-group"
                                        group="a">
                                    <el-collapse-item class="card-shadow--medium" title="Resim Ayarları" name="7">
                                        <el-row>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.resim")'
                                                              prop="resim">:
                                                    <el-upload
                                                            class="resimler"
                                                            action=""
                                                            list-type="picture-card"
                                                            multiple
                                                            :file-list="imageListMain"
                                                            :auto-upload="false"
                                                            accept=".jpg,.jpeg,.png"
                                                            :on-change="imageUpload"
                                                            :on-preview="firstImage"
                                                            :on-remove="imageRemove">
                                                        <i slot="default" class="el-icon-plus"></i>
                                                    </el-upload>
                                                    <el-button style="margin-top: 15px;width: 150px;" type="primary"
                                                               v-on:click="serverImageList"
                                                               @click="dialogImgServerVisible = true; " size="mini">
                                                        Sunucudan
                                                        Seç
                                                    </el-button>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-collapse-item>
                                    <el-collapse-item class="card-shadow--medium" title="SEO Ayarları" name="9">
                                        <el-row>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.seoBaslik")'
                                                              prop="dil.en.seobaslik">:
                                                    <el-input v-on:change="$store.commit('changeTabsClose', false)"

                                                              v-model="haberlerForm.dil.en.seobaslik"
                                                              id="seoBaslikDil"
                                                              @input="seoBaslikChange('seoBaslikDil')"
                                                              :placeholder='$t("src.views.apps.sayfa.tanimlama.seoBaslikPlace")'></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.seoIcerik")'
                                                              prop="dil.en.seoicerik">:
                                                    <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                              type="textarea"
                                                              v-on:focus="seoicerikIngChange = false"
                                                              v-model="haberlerForm.dil.en.seoicerik"></el-input>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-collapse-item>
                                </draggable>
                            </el-collapse>
                        </el-tab-pane>
                    </el-tabs>
                </el-col>
                <el-col :lg="6" :md="6" :sm="24" :xs="24">
                    <el-collapse class="yanForm animated fadeInUp" v-model="activeCollapse">
                        <el-collapse-item class="card-shadow--medium" name="1"
                                          :title='$t("src.views.apps.haberler.tanimlama.durum")'>
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item prop="durum">
                                        <el-select
                                                :disabled="disabled"
                                                v-model="haberlerForm.durum"
                                                :placeholder='$t("src.views.apps.haberler.tanimlama.durumPlace")'
                                                style="width: 100%">
                                            <el-option value="0" label="Taslak">Taslak</el-option>
                                            <el-option value="1" label="Yayınla">Yayınla</el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-button
                                        size="mini" v-on:click="haberTanimlama('haberlerForm',haberlerForm.durum)"
                                        class="onayBtn"
                                        type="primary">
                                    <label v-if="haberlerForm.durum === '1'">
                                        {{$t('src.views.apps.haberler.tanimlama.haberEkle')}}</label>
                                    <label v-else>Kaydet</label>
                                </el-button>
                                &nbsp;
                                <el-popover
                                        placement="bottom"
                                        width="300"
                                        v-model="visibleSil">
                                    <p>{{$t('src.views.apps.yonetici.tanimlama.formAlertP')}}</p>
                                    <div style="text-align: right; margin: 0">
                                        <el-button size="mini" type="primary" @click="resetForm('haberlerForm')">
                                            {{$t('src.views.apps.yonetici.tanimlama.evet')}}
                                        </el-button>
                                        <el-button size="mini" @click="visibleSil = false;">
                                            {{$t('src.views.apps.yonetici.tanimlama.hayir')}}
                                        </el-button>
                                    </div>
                                    <el-button size="mini" slot="reference">
                                        {{$t('src.views.apps.yonetici.tanimlama.temizle')}}
                                    </el-button>
                                </el-popover>
                                <el-tooltip content='Çöp Kutusuna At' :open-delay="500" placement="bottom">
                                    <el-button class="cop" v-on:click="haberTanimlama('haberlerForm','2')"
                                               type="text"
                                               icon="el-icon-delete"></el-button>
                                </el-tooltip>
                            </el-row>
                        </el-collapse-item>
                        <draggable class="list-group" group="a">
                            <el-collapse-item class="card-shadow--medium"
                                              :title='$t("src.views.apps.haberler.tanimlama.kategori")' name="2">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item prop="kategori">
                                            <el-select
                                                    :disabled="disabled"
                                                    v-model="haberlerForm.kategori"
                                                    :placeholder='$t("src.views.apps.haberler.tanimlama.kategoriPlace")'
                                                    style="width: 100%"
                                                    v-on:change="kategoriChange">
                                                <el-option v-for="item in kategoriListe"
                                                           :key="item.hkategoriKodu"
                                                           :label="item.baslik"
                                                           :value="item.hkategoriKodu"></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <div style="font-style: italic">
                                            {{$t("src.views.apps.haberler.tanimlama.kategoriAciklama")}}
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                            <el-collapse-item class="card-shadow--medium"
                                              :title='$t("src.views.apps.haberler.tanimlama.resimKonum")' name="3">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item prop="resimKonum">
                                            <el-button type="primary" size="mini" @click="drawerResimKonum = true">
                                                {{this.btnResim}}
                                            </el-button>
                                            &nbsp;
                                            <img v-if="haberlerForm.resimKonum === '0'" style="float: right"
                                                 src="../../../assets/images/1.png" width="60%" height="60%">
                                            <img v-if="haberlerForm.resimKonum === '1'" style="float: right"
                                                 src="../../../assets/images/2.png" width="60%" height="60%">
                                            <img v-if="haberlerForm.resimKonum === '2'" style="float: right"
                                                 src="../../../assets/images/5.png" width="60%" height="60%">
                                            <img v-if="haberlerForm.resimKonum === '3'" style="float: right"
                                                 src="../../../assets/images/4.png" width="60%" height="60%">
                                            <img v-if="haberlerForm.resimKonum === '4'" style="float: right"
                                                 src="../../../assets/images/3.png" width="60%" height="60%">
                                        </el-form-item>
                                        <div style="font-style: italic">
                                            {{$t("src.views.apps.haberler.tanimlama.resimKonumAciklama")}}
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                            <el-collapse-item class="card-shadow--medium"
                                              :title='$t("src.views.apps.haberler.tanimlama.menuKonum")' name="4">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item prop="menuKonum">
                                            <el-button type="primary" size="mini" @click="drawerMenuKonum = true">
                                                {{this.btnMenu}}
                                            </el-button>
                                            &nbsp;
                                            <img v-if="haberlerForm.menuKonum === '0'" style="float: right"
                                                 src="../../../assets/images/1.png" width="60%" height="60%">
                                            <img v-if="haberlerForm.menuKonum === '1'" style="float: right"
                                                 src="../../../assets/images/6.png" width="60%" height="60%">
                                            <img v-if="haberlerForm.menuKonum === '2'" style="float: right"
                                                 src="../../../assets/images/9.png" width="60%" height="60%">
                                        </el-form-item>
                                        <div style="font-style: italic">
                                            {{$t("src.views.apps.haberler.tanimlama.menuKonumAciklama")}}
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                            <el-collapse-item class="card-shadow--medium"
                                              :title='$t("src.views.apps.haberler.tanimlama.galeriKonum")' name="5">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item prop="galeriKonum">
                                            <el-button type="primary" size="mini" @click="drawerGaleriKonum = true">
                                                {{this.btnGaleri}}
                                            </el-button>
                                            &nbsp;
                                            <img v-if="haberlerForm.galeriKonum === '0'" style="float: right"
                                                 src="../../../assets/images/1.png" width="60%" height="60%">
                                            <img v-if="haberlerForm.galeriKonum === '1'" style="float: right"
                                                 src="../../../assets/images/7.png" width="60%" height="60%">
                                            <img v-if="haberlerForm.galeriKonum === '2'" style="float: right"
                                                 src="../../../assets/images/8.png" width="60%" height="60%">
                                        </el-form-item>
                                        <div style="font-style: italic">
                                            {{$t("src.views.apps.haberler.tanimlama.galeriKonumAciklama")}}
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                            <el-collapse-item class="card-shadow--medium"
                                              :title='$t("src.views.apps.haberler.tanimlama.tarih")' name="6">
                                <el-row :gutter="5">
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24">
                                        <el-row>
                                            <el-col :lg="12" :md="12" :sm="12" :xs="12" class="col-p">
                                                <el-form-item style="position: relative;top: -25px"
                                                              :label='$t("src.views.apps.haberler.tanimlama.baslamaTarihi")'
                                                              prop="tarih">
                                                    <el-date-picker class="select-wide" type="datetime"
                                                                    :disabled="disabled"
                                                                    :placeholder='$t("src.views.apps.haberler.tanimlama.tarihPlace")'
                                                                    :picker-options="dateRangeOptions"
                                                                    v-model="haberlerForm.tarih"
                                                                    format="yyyy-MM-dd HH:mm:ss"
                                                                    value-format="yyyy-MM-dd HH:mm:ss">
                                                    </el-date-picker>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :lg="12" :md="12" :sm="12" :xs="12" class="col-p">
                                                <el-checkbox v-if="!checkedTarih" style="margin-bottom: 15px"
                                                             v-model="checkedTarih">
                                                    {{$t("src.views.apps.haberler.tanimlama.bitisTarihi")}}
                                                </el-checkbox>
                                                <el-col v-if="checkedTarih" :lg="24" :md="24" :sm="24" :xs="24"
                                                        class="col-p">
                                                    <el-form-item style="position: relative;top: -20px"
                                                                  :label='$t("src.views.apps.haberler.tanimlama.bitisTarihi")'
                                                                  prop="bitisTarihi">:
                                                        <el-date-picker class="select-wide" type="datetime"
                                                                        :disabled="disabled"
                                                                        :placeholder='$t("src.views.apps.haberler.tanimlama.bitisTarihiPlace")'
                                                                        :picker-options="dateRangeOptions"
                                                                        v-model="haberlerForm.bitisTarihi"
                                                                        format="yyyy-MM-dd HH:mm:ss"
                                                                        value-format="yyyy-MM-dd HH:mm:ss">
                                                        </el-date-picker>
                                                    </el-form-item>
                                                </el-col>
                                            </el-col>
                                        </el-row>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                            <el-collapse-item class="card-shadow--medium"
                                              :title='$t("src.views.apps.haberler.tanimlama.haberHakkinda")' name="10">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.haberler.tanimlama.sayac")'
                                                      prop="sayac">:
                                            <el-input v-on:change="$store.commit('changeTabsClose', false)"

                                                      v-mask="'######'"
                                                      v-model="haberlerForm.sayac"></el-input>
                                        </el-form-item>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24">
                                            <el-form-item :label='$t("src.views.apps.haberler.tanimlama.begen")'
                                                          prop="begen">:
                                                <el-input v-on:change="$store.commit('changeTabsClose', false)"

                                                          v-mask="'######'"
                                                          v-model="haberlerForm.begen"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                        </draggable>
                    </el-collapse>
                </el-col>
            </el-form>
            <el-dialog
                    title='Sunucudan Fotoğraf Seç'
                    :visible.sync="dialogImgServerVisible"
                    width="60%"
                    center>
                <el-upload
                        action="#"
                        :on-change="serverImageUpload"
                        list-type="picture-card"
                        accept=".jpg,.jpeg,.png"
                        :file-list="imageListServer"
                        :auto-upload="false">
                    <i slot="default" class="el-icon-plus"></i>
                    <div slot="file" slot-scope="{file}">
                        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                        <span class="el-upload-list__item-actions">
                            <span class="el-upload-list__item-delete"
                                  @click="imageUploadtoServer(file)">
                                <i class="el-icon-plus"></i>
                            </span>
                        </span>
                    </div>
                </el-upload>
            </el-dialog>
            <el-dialog
                    title="Resim Konumu"
                    :visible.sync="drawerResimKonum"
                    width="50%">
                <el-row>
                    <el-col :span="8">
                        <el-radio v-model="haberlerForm.resimKonum" label="0" @change="changeKonum('resim','0')">
                            <img src="../../../assets/images/1.png" alt="Yok" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="haberlerForm.resimKonum" label="1" @change="changeKonum('resim','1')">
                            <img src="../../../assets/images/2.png" alt="Sağ" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="haberlerForm.resimKonum" label="2" @change="changeKonum('resim','2')">
                            <img src="../../../assets/images/5.png" alt="Alt" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="haberlerForm.resimKonum" label="3" @change="changeKonum('resim','3')">
                            <img src="../../../assets/images/4.png" alt="Sol" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="haberlerForm.resimKonum" label="4" @change="changeKonum('resim','4')">
                            <img src="../../../assets/images/3.png" alt="Üst" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                </el-row>
            </el-dialog>
            <el-dialog
                    title="Menü Konumu"
                    :visible.sync="drawerMenuKonum"
                    width="50%">
                <el-row>
                    <el-col :span="8">
                        <el-radio v-model="haberlerForm.menuKonum" label="0" @change="changeKonum('menu','0')">
                            <img src="../../../assets/images/1.png" alt="Yok" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="haberlerForm.menuKonum" label="1" @change="changeKonum('menu','1')">
                            <img src="../../../assets/images/6.png" alt="Sağ" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="haberlerForm.menuKonum" label="2" @change="changeKonum('menu','2')">
                            <img src="../../../assets/images/9.png" alt="Alt" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                </el-row>
            </el-dialog>
            <el-dialog
                    title="Galeri Konumu"
                    :visible.sync="drawerGaleriKonum"
                    width="50%">
                <el-row>
                    <el-col :span="8">
                        <el-radio v-model="haberlerForm.galeriKonum" label="0" @change="changeKonum('galeri','0')">
                            <img src="../../../assets/images/1.png" alt="Yok" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="haberlerForm.galeriKonum" label="1" @change="changeKonum('galeri','1')">
                            <img src="../../../assets/images/7.png" alt="Dikey,Büyük" width="80%" height="80%">
                        </el-radio>
                    </el-col>
                    <el-col :span="8">
                        <el-radio v-model="haberlerForm.galeriKonum" label="2" @change="changeKonum('galeri','2')">
                            <img src="../../../assets/images/8.png" alt="Yatay,Küçük" width="80%">
                        </el-radio>
                    </el-col>
                </el-row>
            </el-dialog>
        </el-row>
    </div>
</template>
<script>
    import ClassicEditor from '../../../../node_modules/ckeditor5-build-classic';
    import draggable from "vuedraggable";
    import JQuery from 'jquery';

    let $ = JQuery;

    import seoService from '../../../WSProvider/SeoService'
    import controllerService from '../../../WSProvider/ControllerService'
    import haberService from '../../../WSProvider/HaberService'
    import haberKategoriService from '../../../WSProvider/HaberKategoriService'
    import notification from '../../../notification'

    var today = new Date();
    var yil = today.getFullYear();
    var ay = (today.getMonth() + 1);
    var gun = today.getDate();
    var moment = require('moment');


    let time = moment().format('YYYY-MM-DD HH:mm:ss');
    let base64 = require('base64_js');
    let userDataUio = "";
    export default {
        name: "HaberlerTanimla",
        components: {
            draggable,
        },

        mounted() {
            this.getKategoriListe();
        },
        data() {
            return {
                seoBaslikLimit: 0,
                seoBaslikDilLimit: 0,
                drawerResimKonum: false,
                drawerMenuKonum: false,
                drawerGaleriKonum: false,
                path: haberService.path,
                dialogDocServerVisible: false,
                editor: ClassicEditor,
                editorConfig: {
                    language: 'tr',
                },
                activeCollapse: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
                imageListMain: [],
                imageListServer: [],
                fileListMain: [],
                fileListServer: [],
                VisibleA: false,
                visibleSil: false,
                duzenleBtnVisible: true,
                seoicerikIngChange: true,
                dynamicTags: [],
                visibleWebSite: false,
                disabled: false,
                linkChange: true,
                seoicerikChange: true,
                seoicerikDilChange: true,
                checkedTarih: false,
                kategoriKodu: '',
                btnResim: "Seç",
                btnMenu: "Seç",
                btnGaleri: "Seç",
                kategoriListe: [],
                dialogImgServerVisible: false,
                linkVisible: false,
                dateRangeOptions: {
                    firstDayOfWeek: 1
                },
                haberlerForm: {
                    kategori: '',
                    baslik: '',
                    altbaslik: '',
                    icerik: '',
                    resim: [],
                    belge: [],
                    link: '',
                    sayac: 0,
                    begen: 0,
                    resimKonum: '0',
                    menuKonum: '0',
                    galeriKonum: '0',
                    kaynakca: '',
                    webSite: [],
                    tarih: time,
                    bitisTarihi: '',
                    durum: '1',
                    seobaslik: '',
                    seoicerik: '',
                    firstDayOfWeek: 1,
                    dil: {
                        en: {
                            baslik: '',
                            altbaslik: '',
                            icerik: '',
                            seobaslik: '',
                            seoicerik: ''
                        }
                    }
                },
                rulesHaberler: {
                    baslik: [{
                        required: true,
                        message: "Lütfen Haber Başlığı Giriniz",
                        trigger: 'blur'
                    }],
                    seobaslik: [{
                        max: 70,
                        message: "Tavsiye edilen SEO Başlık limitini aştınız.",
                        trigger: 'change'
                    }],
                    seoicerik: [{
                        max: 140,
                        message: "Tavsiye edilen SEO İçerik limitini aştınız.",
                        trigger: 'change'
                    }],
                    dil: {
                        en: {
                            seoicerik: [{
                                max: 140,
                                message: "Tavsiye edilen SEO İçerik limitini aştınız.",
                                trigger: 'change'
                            }]
                        }
                    },
                    dil: {
                        en: {
                            seobaslik: [{
                                max: 70,
                                message: "Tavsiye edilen SEO Başlık limitini aştınız.",
                                trigger: 'change'
                            }]
                        }
                    }
                },
            }
        },
        methods: {
            seoBaslikChange(id) {
                this.seoBaslikLimit = this.haberlerForm.seobaslik.length;
                this.seoBaslikDilLimit = this.haberlerForm.dil.en.seobaslik.length;
                if (this.seoBaslikLimit > 70) {
                    $('#' + id).closest('div').find('div').addClass('limitAsim');
                } else {
                    $('#' + id).closest('div').find('div').removeClass('limitAsim');
                }
                if (this.seoBaslikDilLimit > 70) {
                    $('#' + id).closest('div').find('div').addClass('limitAsim');
                } else {
                    $('#' + id).closest('div').find('div').removeClass('limitAsim');
                }
            },
            serverImageList() {
                if (localStorage.getItem("imageListServer")) {
                    this.imageListServer = JSON.parse(localStorage.getItem("imageListServer"));
                } else {
                    var dizi = [];
                    controllerService.sunucuResim('haber').then((response) => {
                        if (response.status === 200) {
                            response.data.forEach(function (e) {
                                var item = {
                                    name: e,
                                    url: haberService.imageUrlKucuk + e
                                };
                                dizi.push(item);
                            });
                            this.imageListServer = dizi;
                        }
                    })
                }
            },
            serverImageUpload(file, fileList) {
                if (file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    this.sumResimFonk(file, randomText(7) + '-' + file.name);
                } else {
                    fileList.pop();
                    notification.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },
            getKategoriListe() {
                haberKategoriService.kategoriList(0).then(response => {
                    if (response.status === 200) {
                        if (response.data.length === 0) {
                            notification.Status('warning', this, 'Kategori listesi boş! Lütfen önce kategori tanımlayınız.');
                            this.disabled = true;
                        } else {
                            this.kategoriListe = response.data;
                        }
                        if (response.data.length > 0) {
                            this.haberlerForm.kategori = response.data[0].hkategoriKodu;
                            this.kategoriKodu = response.data[0].hkategoriKodu;
                        }
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
            firstImage(item) {
                var index = this.imageListMain.indexOf(item);
                this.imageListMain.splice(index, 1);
                this.imageListMain.unshift(item);
                notification.Status('success', this, item.name + " ana resim olarak ayarlandı..");
            },
            linkTespitLink() {
                let self = this;
                if (this.haberlerForm.link) {
                    seoService.linkKontrol(self.haberlerForm.link.replace("'", "").substring(0, 60)).then((response) => {
                        if (response.status === 200) {
                            self.haberlerForm.link = response.data;
                        } else {
                            notification.Status(response.status, this)
                        }
                    })
                }
            },
            linkTespit() {
                let self = this;
                if (this.haberlerForm.baslik && this.linkChange) {
                    seoService.linkKontrol(this.haberlerForm.baslik.replace("'", "").substring(0, 60)).then((response) => {
                        if (self.haberlerForm.baslik) {
                            self.haberlerForm.seobaslik = self.haberlerForm.baslik.substring(0, 60);
                            if (response.status === 200) {
                                self.linkVisible = true;
                                self.haberlerForm.link = response.data;
                            }
                        } else if (!self.haberlerForm.baslik) {
                            self.linkVisible = false;
                            self.haberlerForm.link = '';
                            self.haberlerForm.seobaslik = '';
                        }
                    })
                }
            },
            seoIcerikTespit() {
                if (this.seoicerikChange) {
                    const myStr = strip_html_tags(this.haberlerForm.icerik);
                    this.haberlerForm.seoicerik = myStr.substring(0, 140);
                }
            },
            seoIcerikDilTespit() {
                if (this.seoicerikIngChange) {
                    const myStr = strip_html_tags(this.haberlerForm.dil.en.icerik);
                    this.haberlerForm.dil.en.seoicerik = myStr.substring(0, 140);
                }
            },
            kategoriChange(val) {
                if (val === '4') {
                    this.visibleWebSite = true;
                } else {
                    this.visibleWebSite = false;
                }
            },
            sumResimFonk(file, imgname) {
                const files = file.raw;
                if (files) {
                    const reader = new FileReader();
                    reader.onload = e => {
                        const data = e.target.result;
                        controllerService.resimYukle('haber', imgname, data).then((response) => {
                            if (response.status === 200) {
                                this.haberlerForm.resimKonum = '1';
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    };
                    reader.readAsDataURL(files);
                }
            },
            imageUpload(file, fileList) {
                fileList.pop();
                if (file.raw["type"] === 'image/jpg' || file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    if (this.haberlerForm.baslik) {
                        var imgname = randomText(7) + '-' + this.haberlerForm.link + ".png";
                    } else {
                        imgname = randomText(7) + '-' + linkTemizle(file.name.split('.')[0].substring(0, 60)) + ".png";
                    }
                    if (this.imageListMain.length === 0) {
                        var item = {
                            name: imgname,
                            url: file.url,
                            id: file.raw.lastModified
                        };
                        this.imageListMain.push(item);
                        this.sumResimFonk(file, imgname);
                    } else {
                        let obj = this.imageListMain.find(data => data.id === file.raw.lastModified);
                        if (obj === undefined) {
                            item = {
                                name: imgname,
                                url: file.url,
                                id: file.raw.lastModified
                            };
                            this.imageListMain.push(item);
                            this.sumResimFonk(file, imgname);
                        } else {
                            notification.Status('warning', this, 'Bu resim zaten mevcut');
                        }
                    }
                } else {
                    notification.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },
            imageUploadtoServer(file) {
                if (this.imageListMain.length === 0) {
                    var item = {
                        name: file.name.slice(file.name.indexOf("-") + 1),
                        url: file.url,
                    };
                    this.imageListMain.push(item);
                    notification.Status('success', this, file.name.slice(file.name.indexOf("-") + 1) + ' resmi eklendi.');
                } else {
                    let obj = this.imageListMain.find(data => data.name === file.name.slice(file.name.indexOf("-") + 1));
                    if (obj === undefined) {
                        item = {
                            name: file.name.slice(file.name.indexOf("-") + 1),
                            url: file.url,
                        };
                        this.imageListMain.push(item);
                        notification.Status('success', this, file.name.slice(file.name.indexOf("-") + 1) + ' resmi eklendi.');
                    } else {
                        notification.Status('warning', this, 'Bu resim zaten mevcut');
                    }
                }
            },
            imageRemove(file) {
                this.imageListMain.splice(this.imageListMain.indexOf(file), 1);
            },
            haberTanimlama(formName, durum) {
                let self = this;
                this.haberlerForm.resim = [];
                let dil = [];
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.imageListMain.forEach(function (e) {
                            self.haberlerForm.resim.push(e.name);
                        });
                        if (this.$store.state.dilDurum) {
                            dil = {
                                en: {
                                    baslik: this.haberlerForm.dil.en.baslik,
                                    altBaslik: this.haberlerForm.dil.en.altbaslik,
                                    icerik: this.haberlerForm.dil.en.icerik,
                                    seoBaslik: this.haberlerForm.dil.en.seobaslik,
                                    seoIcerik: this.haberlerForm.dil.en.seoicerik
                                },
                            };
                        }
                        haberService.tanimlama(this.haberlerForm.kategori, this.haberlerForm.link, this.haberlerForm.baslik,
                            this.haberlerForm.altbaslik, this.haberlerForm.icerik, this.haberlerForm.seobaslik,
                            this.haberlerForm.seoicerik, this.haberlerForm.resim,
                            this.haberlerForm.resimKonum, this.haberlerForm.menuKonum, this.haberlerForm.galeriKonum,
                            this.haberlerForm.tarih, this.haberlerForm.bitisTarihi,
                            this.haberlerForm.sayac, this.haberlerForm.begen, durum, dil).then((response) => {
                            if (response.status === 200) {
                                switch (durum) {
                                    case '0':
                                        notification.Status('success', this, 'Haber taslağa kaldırıldı.');
                                        break;
                                    case '1':
                                        notification.Status('success', this, 'Haber başarıyla eklendi.');
                                        break;
                                    case '2':
                                        notification.Status('success', this, 'Haber arşive kaldırıldı.');
                                        break;
                                }
                                this.resetForm(formName);
                            } else if (response.status === 230) {
                                notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir haber zaten mevcut');

                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    }
                })
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.visibleSil = false;
                this.visibleWebSite = false;
                this.imageListMain = [];
                this.fileListMain = [];
                this.haberlerForm.kategori = this.kategoriKodu;
                this.haberlerForm.belge = [];
                this.haberlerForm.link = null;
                this.linkVisible = false;
            },
            changeKonum(item, konum) {
                if (item === 'resim') {
                    this.drawerResimKonum = false;
                    this.btnResim = "Değiştir";
                    switch (konum) {
                        case '0' :
                            notification.Status('success', this, 'Resim konumu "Yok" olarak seçildi.');
                            break;
                        case '1' :
                            notification.Status('success', this, 'Resim konumu "Sağ" olarak seçildi.');
                            break;
                        case '2' :
                            notification.Status('success', this, 'Resim konumu "Alt" olarak seçildi.');
                            break;
                        case '3' :
                            notification.Status('success', this, 'Resim konumu "Sol" olarak seçildi.');
                            break;
                        case '4' :
                            notification.Status('success', this, 'Resim konumu "Üst" olarak seçildi.');
                            break;
                    }
                } else if (item === 'menu') {
                    this.drawerMenuKonum = false;
                    this.btnMenu = "Değiştir";
                    switch (konum) {
                        case '0' :
                            notification.Status('success', this, 'Menü konumu "Yok" olarak seçildi.');
                            break;
                        case '1' :
                            notification.Status('success', this, 'Menü konumu "Sağ" olarak seçildi.');
                            break;
                        case '2' :
                            notification.Status('success', this, 'Menü konumu "Alt" olarak seçildi.');
                            break;
                    }
                } else if (item === 'galeri') {
                    this.drawerGaleriKonum = false;
                    this.btnGaleri = "Değiştir";
                    switch (konum) {
                        case '0' :
                            notification.Status('success', this, 'Galeri konumu "Yok" olarak seçildi.');
                            break;
                        case '1' :
                            notification.Status('success', this, 'Galeri konumu "Dikey,Büyük" olarak seçildi.');
                            break;
                        case '2' :
                            notification.Status('success', this, 'Galeri konumu "Yatay,Küçük" olarak seçildi.');
                            break;
                    }
                }
            }
        }
    }

    function linkTemizle(text) {
        var trMap = {
            'çÇ': 'c',
            'ğĞ': 'g',
            'şŞ': 's',
            'üÜ': 'u',
            'ıİ': 'i',
            'öÖ': 'o'
        };
        for (var key in trMap) {
            text = text.replace(new RegExp('[' + key + ']', 'g'), trMap[key]);
        }
        return text.replace(/[^-a-zA-Z0-9\s]+/ig, '')
            .replace(/\s/gi, "-")
            .replace(/[-]+/gi, "-")

    }

    function strip_html_tags(str) {
        str = str.replace(/&nbsp;/gi, '');
        if ((str === null) || (str === ''))
            return false;
        else
            str = str.toString();
        var str1 = str.replace(/<[^>]*>/g, '');
        return str1.replace(/&nbsp;/g, '');
    }

    function randomText(length) {

        let bugun = yil + '' + (ay <= 9 ? '0' + ay : ay) + '' + (gun <= 9 ? '0' + gun : gun);

        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < length; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        return bugun + "-" + text;
    }

</script>

<style scoped>

    .upload-demo ul {
        margin: 0;
        padding: 0;
        list-style: none;
        background: aliceblue;
        width: 50%;
    }

    .cop {
        color: #ec205f;
        position: relative;
        float: right;
        right: 15px;
        bottom: 10px;
        font-size: 20px;
    }

    .el-tag + .el-tag {
        margin-left: 10px;
    }


</style>